export class OpenDialog {
  static readonly type = '[Amautas subscription dialog] - Open dialog';
}

export class CloseDialog {
  static readonly type = '[Amautas subscription dialog] - Close dialog';
}

export class OpenUrl {
  static readonly type = '[Amautas subscription dialog] - Open url';
}
